import { AnyAction } from 'redux'

import * as actionsTypes from 'apps/applications/constants/ReduxActionTypes'
import { IApplicationReviewReportState } from 'common/actions/integrations/Applications/interfaces'

import { fetchReviewReport } from '../actions/applicationsActions'

const initialState: IApplicationReviewReportState = {
  applicationId: null,
  fetching: false,
  report: '',
}

export default function currentApplicationReducer(
  state: IApplicationReviewReportState = initialState,
  action: AnyAction,
) {
  switch (action.type) {
    case actionsTypes.APPLICATION_REVIEW_REPORT_MODAL_OPEN:
      return { ...state, applicationId: action.applicationId }
    case actionsTypes.APPLICATION_REVIEW_REPORT_MODAL_CLOSE:
      return { ...state, applicationId: null }
    case fetchReviewReport.pending.type:
      return { ...state, fetching: true, report: '' }
    case fetchReviewReport.fulfilled.type:
      return { ...state, fetching: false, report: action.payload }
    case fetchReviewReport.rejected.type:
      return { ...state, fetching: false }
  }

  return state
}
